<template>
<div class="left-menu">
  <div>{{nowTab}}</div>
  <ul>
    <li @click="jump('/style2/home',{navIndex:1})" :class="tabIndex === 1?'act':''">公司首页</li>
    <li @click="jump('/style2/info',{navIndex:2})" :class="tabIndex === 2?'act':''">企业文化</li>
    <li @click="jump('/style2/project',{navIndex:3})" :class="tabIndex === 3?'act':''">历史项目</li>
    <li @click="jump('/style2/news',{navIndex:4})" :class="tabIndex === 4?'act':''">新闻公告</li>
    <li @click="jump('/style2/contact',{navIndex:5})" :class="tabIndex === 5?'act':''">联系我们</li>
  </ul>
</div>
</template>

<script>
export default {
  name: 'LeftMenu',
  computed: {
    tabIndex() {
      return this.$store.state.tabIndex;
    },
    nowTab() {
      return ['', '公司首页', '企业文化', '历史项目', '新闻公告', '联系我们', '专家抽取'][this.tabIndex];
    },
  },
};
</script>

<style scoped>

</style>
